let storedToken: string | null = null

export class SlidoAuthService {
  static setAuthToken(token: string) {
    storedToken = token
  }

  static getAuthToken(): string | null {
    // First try in-memory stored token
    if (storedToken) {
      return storedToken
    }

    // Then try URL parameter (for iframe communication)
    const urlParams = new URLSearchParams(window.location.search)
    const tokenFromUrl = urlParams.get('auth_token')
    if (tokenFromUrl) {
      storedToken = tokenFromUrl
      return tokenFromUrl
    }

    // Then try cookies (for subdomain sharing)
    return document.cookie
      .split('; ')
      .find(row => row.startsWith('auth_token='))
      ?.split('=')[1] || null
  }
}



